import { Page, Container, ContentHeader } from 'components'
import { PaymentServiceTemplateForm } from './components'

const PaymentServiceTemplatesNew = () => {
  return (
    <Page title="Novo tipo de serviço">
      <Container maxWidth={false}>
        <ContentHeader
          title="Criação"
          menu="Vendas"
          subtitle="Criação de tipo de serviço"
        />
        <PaymentServiceTemplateForm />
      </Container>
    </Page>
  )
}

export default PaymentServiceTemplatesNew
